// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: decisions/0029-principal-scoped-credential-grants.md
import * as React from 'react';
import { Lock } from 'lucide-react';

import { cn } from '@/lib/utils';

/** Why a grant is held at pending by its credential's group requirement. */
export function HeldReason({
  reason,
  className,
}: {
  reason: string;
  className?: string;
}): React.JSX.Element {
  return (
    <p
      className={cn('flex items-start gap-1.5 text-[12px] leading-snug text-foreground', className)}
    >
      <Lock className="mt-0.5 h-3 w-3 shrink-0 text-gl-amber-text" aria-hidden="true" />
      <span>
        <span className="font-medium">Held:</span> {reason}.
      </span>
    </p>
  );
}
